/**
 * トースト（Snackbar）の z-index。MUI theme.zIndex.snackbar と ToastContext で共有。
 * DetailView 1400 / OperationLog 1500 / UseCaseEdit 内 Detail 3200 / StepEditor 10001 より上。
 */
export const TTM_TOAST_SNACKBAR_Z_INDEX = 11000;

/** GraphView の PageHeader 高さ（TestTargetGraphView が documentElement に同期） */
export const TTM_PAGE_HEADER_HEIGHT_CSS_VAR = "--ttm-page-header-height";
